/**
 * Générateur — Automatisme : 10² = 100 ; 10³ = 1 000.
 * Attendu ID : 1104 | Niveau : 4ème | Domaine : Puissances
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 9, ligne 678 :
 * « 10² = 100 ; 10³ = 1 000. »).
 *
 * ── WRAPPER de gen_1103 (puissances simples), RESTREINT À LA BASE 10 ──────
 * Le même gen, les cartes `dix_*` seulement (dispatch par clé, comme les
 * clés produits_/quotients_ de 1043) : un re-badge nu ferait sortir 2³ sous
 * cet id. Rien de neuf en calcul (10³ = 5e l. 591, gen_928) : le couple
 * 10²/10³ comme faits nus, dans les deux sens, avec la notation
 * 10 × 10 × 10 = 10^… (5e l. 589) ; 10⁴ jamais (ancien gen 136). Le wrapper
 * de gen_928 a été écarté (gen d'objectif : dé géant, trous en mots ; choix
 * mode auto, À ARBITRER). Payload re-badgé (attendu 1104) ; les solveurs
 * sont ceux des clés dix_* de 1103.
 */
import { generate as genererPuissances, CATEGORIES_DIX } from './gen_1103';
import { randomChoice, retirerCodesErreur } from '../../../utils';

const ATTENDU_ID = 1104;

// Relecture du 04/10/2026 (docs/SFD_CODES_ERREUR.md) : base_fois_exposant n'est gardé que sur les cartes de
// 1103 où le juge l'a lu ; celles de 1104 ne lui ont jamais été montrées. Le choix reste proposé, sans nom.
const CODES_RETIRES = {
    dix_valeur_qcm_unique: ['base_fois_exposant'],
    dix_sens_tableau_vf: ['base_fois_exposant'],
};

export const CATEGORIES = CATEGORIES_DIX;

const CLES = CATEGORIES_DIX.flatMap((c) => c.formatsList.map(({ key }) => key));

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && CLES.includes(typeExercice)) key = typeExercice;
    else if (typeExercice) {
        const matching = CLES.filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(CLES);
    } else key = randomChoice(CLES);
    const payload = genererPuissances(key);
    payload.attendu = ATTENDU_ID;
    return retirerCodesErreur(payload, CODES_RETIRES[key]);
};
